import { GiftCardTypes } from '@/domain/cart/types';
import { ApplyableGiftCard } from '@/checkout/types';

export const classifyGiftCardType = (giftCard: Partial<ApplyableGiftCard>): GiftCardTypes => {
  const legacyRegExp = /^[6|7]/;
  const thirdPartyRegExp = /^4436 13|443613/;

  if (giftCard?.savedInfo) return giftCard?.savedInfo.type;
  if (legacyRegExp.test(giftCard.cardNumber || '')) return GiftCardTypes.Legacy;
  if (thirdPartyRegExp.test(giftCard?.cardNumber || '')) return GiftCardTypes.ThirdParty;

  return GiftCardTypes.None;
};
